import { createContext } from 'react';
import type { MaintenanceLevel } from '@/api/appCompatibility';

export type MaintenanceState = {
  level: MaintenanceLevel;
  retryAfterSeconds: number | null;
};

/**
 * Read API exposed by AppCompatibilityProvider. The provider remains the single
 * owner of the compatibility state and all its side effects (sync pause, force
 * screen, self-healing); this context only *publishes* the maintenance slice so
 * AppLayout can render the sticky <MaintenanceBanner/> in-flow, under its header
 * (C.6). Force-update stays a full-screen overlay owned by the provider — it is
 * not page content and is intentionally not exposed here.
 *
 * Split into its own module (not the provider file) so the provider keeps
 * exporting only its component, matching the AuthContext / SelectedStationContext
 * convention and keeping React Fast Refresh happy.
 */
export type AppCompatibilityContextValue = {
  maintenance: MaintenanceState | null;
};

export const AppCompatibilityContext = createContext<AppCompatibilityContextValue | undefined>(
  undefined
);
